import script from "./VLotPositionCreateParametersForm.vue?vue&type=script&setup=true&lang=js"
export * from "./VLotPositionCreateParametersForm.vue?vue&type=script&setup=true&lang=js"

import "./VLotPositionCreateParametersForm.vue?vue&type=style&index=0&id=7a3e8a70&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a3e8a70"]])

export default __exports__